export default "__VITE_ASSET__Dzn8C0oU__"